import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { "data-club-card-info": "" } },
    [
      _c(
        "CoreDialog",
        {
          attrs: {
            "data-qa": "club_card_info",
            title: "Ваша клубная карта",
            "min-height": _vm.isMobile ? undefined : "720px",
            size: _vm.isMobile ? "fullscreen" : "lg",
            divider: "",
          },
          scopedSlots: _vm._u([
            {
              key: "prependBtn",
              fn: function ({ btnProps }) {
                return [
                  _c(
                    VBtn,
                    _vm._b(
                      { on: { click: _vm.handleCloseDialog } },
                      "v-btn",
                      btnProps,
                      false
                    ),
                    [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
                  ),
                ]
              },
            },
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        color: "primary",
                        "data-qa": "club_card_info_fixed_close_button",
                        depressed: "",
                        block: "",
                      },
                      on: { click: _vm.handleCloseDialog },
                    },
                    [_vm._v("\n        Закрыть\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.isDialogVisible,
            callback: function ($$v) {
              _vm.isDialogVisible = $$v
            },
            expression: "isDialogVisible",
          },
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "club-card-info__card-container" }, [
            _c(
              "div",
              {
                staticClass: "club-card-info__card text-body-1 bg-gray-0--text",
              },
              [
                _c("div", { staticClass: "d-flex align-center text-h6" }, [
                  _c("img", {
                    staticClass: "mr-2",
                    attrs: {
                      src: "/static/_v1/pd/icons/ui-kit/club/club-percent-white.svg",
                      width: "24",
                      height: "24",
                      alt: "Иконка Процент Клуба",
                    },
                  }),
                  _vm._v("\n          Клуб ПроДокторов\n        "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column align-center" }, [
                  _c("img", {
                    staticClass: "mb-2",
                    attrs: {
                      src: "/static/_v1/pd/icons/ui-kit/club/club-check-white.svg",
                      width: "72",
                      height: "72",
                      alt: "Иконка Галочка Клуба",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "text-h6 mb-1",
                      attrs: { "data-qa": "club_card_info_user_phone" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formattedPhone) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-body-2" }, [
                    _vm._v(
                      "\n            в клубе до " +
                        _vm._s(_vm.clubData.cardDateEnd) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("\n          Если возникнут вопросы:\n          "),
                  _c("br"),
                  _vm._v("8 800 707-31-29\n        "),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }